import React, { useState } from "react"
import { Link } from "./utils"

type ButtonVariant = "primary" | "ghost" | "light"
type ButtonProps = {
    title: string
    to?: string
    type?: any
    label?: string
    disabled?: boolean
    variant?: ButtonVariant
    className?: string
    iconLeft?: JSX.Element
    iconRight?: JSX.Element
}
const Button: React.FC<ButtonProps> = props => {
    const { title, to, type, label, disabled, variant = "primary" } = props

    // Written out in full so Tailwind's production purge can see the literals.
    const variantClass =
        variant === "ghost"
            ? "btn-ghost"
            : variant === "light"
            ? "btn-light"
            : "btn-primary"

    const classes = `btn ${variantClass}${
        props.className ? ` ${props.className}` : ""
    }`

    const innerComponents = (
        <React.Fragment>
            {props.iconLeft && (
                <span className="icon icon-left">{props.iconLeft}</span>
            )}
            <span>{title}</span>
            {props.iconRight && (
                <span className="icon icon-right">{props.iconRight}</span>
            )}
        </React.Fragment>
    )

    if (type) {
        const b = type.split(",")
        const t = b[1] ? b[1] : "button"
        const dis = disabled === undefined ? false : disabled
        if (b[0] === "button") {
            return (
                <button
                    type={t}
                    disabled={dis}
                    className={`${classes}${dis ? " disabled" : ""}`}
                >
                    {innerComponents}
                </button>
            )
        }
    }
    return (
        <Link to={to} className={classes} title={label || title}>
            {innerComponents}
        </Link>
    )
}

const TextInput = ({ label, type = "text", name, onChange, footer }) => {
    const [focused, changeFocused] = useState(false)

    let elem = (
        <input
            type={type}
            name={name}
            onFocus={() => changeFocused(true)}
            onBlur={() => changeFocused(false)}
            onChange={onChange}
            aria-label={name}
        />
    )

    if (type === "textarea") {
        elem = (
            <textarea
                name={name}
                rows={4}
                className="resize-none"
                onChange={event => {
                    event.target.style.height = "auto"
                    event.target.style.height = event.target.scrollHeight + "px"

                    onChange(event)
                }}
                onFocus={() => changeFocused(true)}
                onBlur={() => changeFocused(false)}
                aria-label={name}
            />
        )
    }

    return (
        <div className={`field mb-10${focused ? " focused" : ""}`}>
            <span className="field-label">{label}</span>
            {elem}
            {footer && <>{footer}</>}
        </div>
    )
}

export { Button, TextInput }
